<div class="wrapper">
  <app-header />
  <div [ngClass]="{'main-content':!showFbdmsPage}">
    <router-outlet></router-outlet>
  </div>
  <app-footer />
</div>